(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5001],{

/***/ 21152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-pages-v2/[...slug]",
      function () {
        return __webpack_require__(12232);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _components_landing_pages_v2_ContactSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80557);
/* harmony import */ var _components_landing_pages_v2_FCContactUs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99782);
/* harmony import */ var _components_landing_pages_v2_FCHero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95534);
/* harmony import */ var _components_landing_pages_v2_FCMap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49581);
/* harmony import */ var _components_landing_pages_v2_FCMissionStatement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81054);
/* harmony import */ var _components_landing_pages_v2_FCProductOptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72034);
/* harmony import */ var _components_landing_pages_v2_FCTestimonialCarousel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96889);
/* harmony import */ var _components_landing_pages_v2_FCThreeSteps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23208);
/* harmony import */ var _components_landing_pages_v2_FCTrustBanner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43649);
/* harmony import */ var _components_landing_pages_v2_HeroV2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67236);
/* harmony import */ var _components_landing_pages_v2_HeroV2WithMarkers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40066);
/* harmony import */ var _components_landing_pages_v2_LWCHeroCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83530);
/* harmony import */ var _components_landing_pages_v2_LWCImageCard__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26923);
/* harmony import */ var _components_landing_pages_v2_LWCTextSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21277);
/* harmony import */ var _components_landing_pages_v2_MapBackgroundHero__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81131);
/* harmony import */ var _components_landing_pages_v2_PhotoTestimonials__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96309);
/* harmony import */ var _components_landing_pages_v2_Spacer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6902);
/* harmony import */ var _components_landing_pages_v2_StandaloneText__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(94479);
/* harmony import */ var _dynamicEntry__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(42336);



















// CarouselCards swaps mobile/desktop subtrees via useMedia, so it stays client-only.
var CarouselCards = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_18__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 9544).then(__webpack_require__.bind(__webpack_require__, 99544));
});
var homePageV2EntryLookup = {
    // only including blocks used in https://app.contentful.com/spaces/bjlp9d7o6h1o/entries/3jH3XGe228kfdp8fBGddyW?focusedField=slug
    // for performance
    block: {
        lpComponentMapBackgroundHero: _components_landing_pages_v2_MapBackgroundHero__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,
        lpComponentCarouselCards: CarouselCards,
        lpComponentContactSection: _components_landing_pages_v2_ContactSection__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
        lpComponentLwcTextSection: _components_landing_pages_v2_LWCTextSection__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
        lpComponentLwcHeroCard: _components_landing_pages_v2_LWCHeroCard__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
        lpComponentLwcImageCard: _components_landing_pages_v2_LWCImageCard__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
        lpComponentHeroV2: _components_landing_pages_v2_HeroV2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP,
        lpComponentHeroV2WithMarkers: _components_landing_pages_v2_HeroV2WithMarkers__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
        lpComponentSpacer: _components_landing_pages_v2_Spacer__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z,
        lpComponentStandaloneText: _components_landing_pages_v2_StandaloneText__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z,
        fcHero: _components_landing_pages_v2_FCHero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        fcTrustBanner: _components_landing_pages_v2_FCTrustBanner__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
        fcThreeSteps: _components_landing_pages_v2_FCThreeSteps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
        fcProductOptions: _components_landing_pages_v2_FCProductOptions__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        fcTestimonialCarousel: _components_landing_pages_v2_FCTestimonialCarousel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
        fcMap: _components_landing_pages_v2_FCMap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
        fcMissionStatement: _components_landing_pages_v2_FCMissionStatement__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        fcContactUs: _components_landing_pages_v2_FCContactUs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
        lpComponentPhotoTestimonials: _components_landing_pages_v2_PhotoTestimonials__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z
    },
    inline: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (homePageV2EntryLookup);


/***/ }),

/***/ 49428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ StickyCTABarContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99758);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);



var StickyCTABarContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    visible: false,
    setVisible: function() {
        return null;
    }
});
var StickyCTABarContextProvider = function(param) {
    var children = param.children;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), visible = ref[0], setVisible = ref[1];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StickyCTABarContext.Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        },
        children: children
    });
};


/***/ }),

/***/ 12232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93089);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var cms_entries_homePageV2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87702);
/* harmony import */ var cms_entries_landingPageV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9758);
/* harmony import */ var cms_renderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51803);
/* harmony import */ var helpers_observability__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50138);
/* harmony import */ var helpers_ReturnExperienceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69814);
/* harmony import */ var helpers_StickyCTABarContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49428);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93287);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var pages_shared_LandingPageV2Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44632);
/* harmony import */ var react_scroll_parallax__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81584);













var LandingPageWithContext = function(props) {
    var trackJourneyEvent = (0,helpers_observability__WEBPACK_IMPORTED_MODULE_4__/* .useObservability */ .C3)().trackJourneyEvent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var nextJsPath = router.asPath.split("?")[0];
    var isHomePage = nextJsPath === "/"; // || true to debug HP perf
    var cmsEntryLookup = isHomePage ? cms_entries_homePageV2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z : cms_entries_landingPageV2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // only measuring homepage load-time performance
        if (false) {}
        // only measuring if the slug contains 'homepage'
        // we have a few variants of the homepage like /homepage-syw-v2-home-guide
        if (window.location.pathname !== "/") return;
        trackJourneyEvent("platform", "pageLoadedEvent", {
            // Next.js route, which is not necessarily the client-side URL
            routerPath: nextJsPath,
            loadTimeMs: Math.round(performance.now())
        });
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(react_scroll_parallax__WEBPACK_IMPORTED_MODULE_9__/* .ParallaxProvider */ .Xu, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(helpers_ReturnExperienceContext__WEBPACK_IMPORTED_MODULE_5__/* .ReturnExperienceContextProvider */ .Q, {
            showReturnExperience: props.fields.showReturnExperienceBanner,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(helpers_StickyCTABarContext__WEBPACK_IMPORTED_MODULE_6__/* .StickyCTABarContextProvider */ .H, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(pages_shared_LandingPageV2Layout__WEBPACK_IMPORTED_MODULE_8__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(cms_renderer__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Component */ .Z.Component, {
                        body: props.fields.body,
                        idToLoaderData: props.idToLoaderData,
                        entryLookup: cmsEntryLookup
                    })
                }))
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (LandingPageWithContext);


/***/ }),

/***/ 76474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconChevronLeft; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25793);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M15 6l-6 6l6 6", "key": "svg-0" }]];
const IconChevronLeft = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "chevron-left", "ChevronLeft", __iconNode);


//# sourceMappingURL=IconChevronLeft.mjs.map


/***/ }),

/***/ 31009:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconHome; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25793);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M5 12l-2 0l9 -9l9 9l-2 0", "key": "svg-0" }], ["path", { "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6", "key": "svg-2" }]];
const IconHome = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "home", "Home", __iconNode);


//# sourceMappingURL=IconHome.mjs.map


/***/ }),

/***/ 39908:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconLogout2; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25793);
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2", "key": "svg-0" }], ["path", { "d": "M15 12h-12l3 -3", "key": "svg-1" }], ["path", { "d": "M6 15l-3 -3", "key": "svg-2" }]];
const IconLogout2 = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("outline", "logout-2", "Logout2", __iconNode);


//# sourceMappingURL=IconLogout2.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5653,4607,9115,820,9560,1028,2732,7573,2595,6184,1850,1584,3680,6492,7114,6121,3476,2766,589,2395,9712,4482,7987,7488,4632,9774,2888,179], function() { return __webpack_exec__(21152); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);